<script>
    export let tic;
</script>
<svg
              class={tic}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <path d="M3 19l15 -15l3 3l-6 6l2 2a14 14 0 0 1 -14 4" />
            </svg>